import React, { useState } from "react";
import { Modal, Button, ProgressBar } from "react-bootstrap";

const steps = [
    {
        title: "Step 1: Review Connection Requests",
        content: (
            <>
                <p className="font-weight-bold">
                    Help Job Seekers
                </p>
                <p>
                    As a Support Team Member, you'll receive connection requests from job
                    seekers who are looking for guidance.
                </p>
                <p>
                    When a job seeker sends you their resume and asks for tips, contacts,
                    or advice, take a few minutes to review their background and provide
                    helpful feedback.
                </p>
                <p>
                    Your insights and connections can make a significant difference in
                    their job search journey.
                </p>
            </>
        ),
    },
    {
        title: "Step 2: Provide Valuable Guidance",
        content: (
            <>
                <p>
                    Share your professional experience and industry knowledge to help job
                    seekers improve their chances of success.
                </p>
                <p>
                    If you know of any job openings or professional contacts that might be
                    helpful, feel free to share them. However, you're never obligated to
                    share personal contact information unless you choose to.
                </p>
            </>
        ),
    },
    {
        title: "Step 3: Make a Difference",
        content: (
            <>
                <p>
                    Remember that your participation is voluntary and compassionate. Even
                    a few minutes of your time can provide extremely valuable information
                    to someone who is struggling with employment.
                </p>
                <p>
                    Check the "Connections" section regularly to respond to new requests,
                    and review sponsorship opportunities to support job seekers who align
                    with your expertise.
                </p>
                <p>
                    Your empathy and willingness to help others is what makes this
                    community thrive.
                </p>
            </>
        ),
    },
];

export default function SupportOnboardingModal({ show, onHide, onFinish }) {
    const [step, setStep] = useState(0);

    const handleNext = () => {
        if (step < steps.length - 1) setStep(step + 1);
        else {
            if (onFinish) onFinish(true);
            onHide();
            setStep(0); // reset for next open
        }
    };

    const handleBack = () => {
        if (step > 0) setStep(step - 1);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{steps[step].title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProgressBar now={((step + 1) / steps.length) * 100} className="mb-3" />
                {steps[step].content}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleBack} disabled={step === 0}>
                    Back
                </Button>
                <Button variant="primary" onClick={handleNext}>
                    {step === steps.length - 1 ? "Finish" : "Next"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
